import { render, staticRenderFns } from "./ChangePartialAreaToNewBigArea.vue?vue&type=template&id=cc90c8c0"
import script from "./ChangePartialAreaToNewBigArea.vue?vue&type=script&lang=ts"
export * from "./ChangePartialAreaToNewBigArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports